// extracted by mini-css-extract-plugin
export default {"cls1":"NewsHeader-cls1__aS","cls2":"NewsHeader-cls2_Smk NewsHeader-cls1__aS"};